<!--树形单选-->
<template>
	<div class="selectionBody" @mouseenter="showSelection = true" @mouseleave="showSelection = false">
		<p :style="getTitleBackGroud" :title="nowTitle">{{nowTitle}}</p>
		<listSelection v-show="showSelection" :targetMethod="targetMethod" :dataList="dataList" class="selection" @checkItem="nowItem = $event,showSelection = false" :getNameMethod="getNameMethod"></listSelection>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import listSelection from '@/components/module/selection/base/listSelection.vue'

	export default {
		components: {
			listSelection
		},
		props: {
			getNameMethod:{
				type:Function,
				default(item){
					if(item == undefined){
						return '未选中'
					}
					return item.name
				}
			},
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			targetMethod:{
				type:Function,
				default:undefined
			}
		},
		data() {
			return {
				nowItem: undefined,
				showSelection: false
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			getTitleBackGroud() {
				if (!this.showUl) {
					return resourcesStore.getters.getBackgroudImageStyle('multipleSelection/arrowDown.png')
				}
				return resourcesStore.getters.getBackgroudImageStyle('multipleSelection/arrowUp.png')
			},
			nowTitle() {
				return this.getNameMethod(this.nowItem)
			},
		},
		watch: {
			nowItem(nv,ov){
				this.$emit("checkItem",nv)
			}
		},
		methods: {
			setNowItem(item){
				this.nowItem = item
			}
		}
	}
</script>

<style scoped>
	.selectionBody {
		width: 200px;
		color: black;
		cursor: pointer;
		position: relative;
	}

	.selectionBody>p {
		padding: .05rem;
		white-space: nowrap;
		background: white;
		height: .2rem;
		text-overflow: ellipsis;
		overflow: hidden;
		width: calc(100% - 38px - 2px);
		padding-right: 38px;
	}

	.selectionBody>.selection {
		position: absolute;
		z-index: 100;
		border-left: silver 1px solid;
	}
</style>
